var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDopplerChatLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 58,
    height: 58,
    viewBox: "44 39 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_di_243_1828)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 65.6899,
    y: 60,
    width: 58,
    height: 58,
    rx: 8,
    transform: "rotate(6 65.6899 60)",
    fill: "#004C4B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.0677 76.9551C95.8103 77.2434 98.4856 77.9147 100.941 78.9307C103.396 79.9467 105.583 81.2876 107.376 82.8766C109.17 84.4657 110.536 86.2719 111.395 88.1922C112.254 90.1124 112.591 92.109 112.385 94.0681C112.179 96.0271 111.435 97.9102 110.195 99.6098C108.955 101.309 107.244 102.792 105.159 103.974C103.074 105.155 100.656 106.012 98.0435 106.495C95.4308 106.979 92.6745 107.079 89.9318 106.791L91.4998 91.873L93.0677 76.9551Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDopplerChatLogo);
export default __webpack_public_path__ + "static/media/doppler_chat_logo.a71b77756701d9c7b5b7f29b5bcfa2c7.svg";
export { ForwardRef as ReactComponent };